import headerBackground from './headerBackground.svg'
import {
  Button,
  GreyGrey30,
  GreyGrey70,
  GreyGrey90,
  IconBookOpen,
  Image,
  PageTitle,
  Primary13Regular,
  Primary16SemiBold,
  Box,
  Flex,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { useIntegrationManagementHeader } from 'modules/Integrations/view/integrationManagement/useIntegrationManagementHeader'

export const IntegrationManagementHeader = () => {
  const hook = useIntegrationManagementHeader()
  return (
    <>
      <PageTitle title={[hook.integration.title, 'Connectors']} />
      <Grid
        width="100%"
        padding="20px"
        minHeight="132px"
        backgroundImage={headerBackground}
        gridTemplateColumns="48px 1fr"
        gridTemplateRows="48px auto"
        gridTemplateAreas={`
        "logo description"
        "empty actions"
      `}
        gridColumnGap="16px"
        gridRowGap="12px"
        borderBottom={`1px solid ${GreyGrey30}`}
      >
        <GridItem
          gridArea="logo"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Image src={hook.integration.logoUrl} width="100%" maxHeight="100%" />
        </GridItem>
        <GridItem gridArea="description">
          <Box {...Primary16SemiBold} color={GreyGrey90}>
            {hook.integration.title}
          </Box>
          <Box {...Primary13Regular} color={GreyGrey70}>
            {hook.integration.description}
          </Box>
        </GridItem>
        <GridItem gridArea="actions" display="flex" gap="8px">
          <Button
            variant="secondary"
            onClick={hook.onDocumentationClick}
            data-testid="integrationManagement.header.documentation"
          >
            <Flex gap="8px">
              <IconBookOpen />
              Documentation
            </Flex>
          </Button>
        </GridItem>
      </Grid>
    </>
  )
}
